import 'hammerjs';
import { APP_DATE_FORMATS } from "./Common/app-date-adapter";
var DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    suppressScrollX: true,
    minScrollbarLength: 50,
    maxScrollbarLength: 300
};
var ɵ0 = APP_DATE_FORMATS, ɵ1 = DEFAULT_PERFECT_SCROLLBAR_CONFIG;
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/app.module.ts.pre-build-optimizer.js